import { useState } from "react";
import _ from "lodash";
import moment from "moment";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import { Formik } from "formik";
import Layout from "../../common/Layout";
import { Link } from "react-router-dom";
import ItemsGrid from "../../common/components/widgets/ItemsGrid";
// TODO: Commented out GraphQL import - now using REST hook useUserGroups
// import { GET_USER_GROUPS } from "./../userGroup/queries";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from "react-select";
import CSVService from "../CSVservice";
import TextField from "@material-ui/core/TextField";
import Swal from "sweetalert2";
import { Box } from "@material-ui/core";
import LoadingSpinner from "../../common/components/LoadingSpinner/LoadingSpinner";
import UploadPhotoDialog from "./UploadPhotoDialog";
import { env } from "../../env";
import useAppStore from "../../store/appStore";
import { useUserById } from "../../hooks/useUserById";
import { useChallengeNames } from "../../hooks/useChallengeNames";
import { useUserChallenges } from "../../hooks/useUserChallenges";
import { useUserGroups } from "../../hooks/useUserGroups";
import { useUpdateUser } from "../../hooks/useUpdateUser";
import { useDeleteUser } from "../../hooks/useDeleteUser";
import { useUploadPhoto } from "../../hooks/useUploadPhoto";
import { useRemovePhoto } from "../../hooks/useRemovePhoto";
import { useResetChallenge } from "../../hooks/useResetChallenge";
import { useVerifyEmail } from "../../hooks/useVerifyEmail";
import { RolesTypes } from "../../constants/roles";
import { ImportExport } from "@material-ui/icons";

const columns = ["challengeType", "challengeTitle", "scores", "action"];
const columnsName = ["challenge Nr", "title", "scores", "action"];


/* TODO: Replaced DELETE_USER mutation with REST hook useDeleteUser
const DELETE_USER = gql`
  mutation deleteUser($id: String){
    deleteUser(id: $id)
  }
`;
*/



/* TODO: Replaced VERIFY_MAIL_BY_ID mutation with REST hook useVerifyEmail
const VERIFY_MAIL_BY_ID = gql`
    mutation($id: String!) {
        verifyMailById(id: $id)
    }
`;
*/

const UserProfile = props => {
  const id = props.match.params.id;
  const [userChallengesList, setUserChallengesList] = useState([]);

  // Inject custom style for SweetAlert
  if (!document.getElementById('swal-custom-style')) {
    const style = document.createElement('style');
    style.id = 'swal-custom-style';
    style.innerHTML = `
      .swal-small-title {
        font-size: 1.4em !important;
      }
    `;
    document.head.appendChild(style);
  }

  // Get user data from Zustand store instead of GraphQL
  const user = useAppStore(state => state.user);
  const loading = !user || !user.me;
  const data = user ? { me: user.me } : null;
  const error = null;

  // Replace GraphQL GET_USER_DATA with REST hook
  const {
    data: userDataRest,
    isFetching: userDataLoading,
    error: userDataError
  } = useUserById(id);
  const userDataQuery = {
    data: userDataRest,
    loading: userDataLoading,
    error: userDataError
  };

  // Replace GraphQL GET_USER_GROUPS with REST hook
  const {
    data: userGroupsData,
    isFetching: userGroupsLoading,
    error: userGroupsError
  } = useUserGroups();
  const userGroupsQuery = {
    data: {
      userGroups: userGroupsData?.userGroups || {
        records: [],
        totalCount: 0,
        pages: 0
      }
    },
    loading: userGroupsLoading,
    error: userGroupsError
  };
  // Replace GraphQL GET_CHALLENGE_DEFINITIONS with REST hook
  const {
    data: challengeNamesData,
    isFetching: challengeNamesLoading,
    error: challengeNamesError
  } = useChallengeNames();
  const challengeDefinitionsQuery = {
    data: {
      challengeDefinitions: challengeNamesData?.challengeDefinitionNames || []
    },
    loading: challengeNamesLoading,
    error: challengeNamesError
  };
  // Replace GraphQL GET_USER_CHALLENGES with REST hook
  const userEmail = userDataQuery.data?.email; 

  const {
    data: userChallengesData,
    isFetching: userChallengesLoading,
    error: userChallengesError,
    refetch: refetchUserChallenges
  } = useUserChallenges(
    userEmail,  
    { enabled: !!userEmail }  
  );

  const userChallengesQuery = {
    data: {
      userChallenges: userChallengesData?.userChallenges || {
        records: [],
        pages: 0,
        totalCount: 0
      }
    },
    loading: userChallengesLoading,
    error: userChallengesError
  };
  const [uploadDialog, setUploadDialog] = useState(false);
  const deleteUserMutation = useDeleteUser({
    onError: error => {
      Swal.fire({
        title: error.message,
        type: "error",
        customClass: {
          title: 'swal-small-title'
        }
      });
    },
    onSuccess: () => {
      Swal.fire("User deleted!", "", "success");
      props.history.push("/admin-settings/users");
    }
  });
  
  // Extract isPending from mutations
  const {isPending: isDeletingUser } = deleteUserMutation;
  
  const updateUserMutation = useUpdateUser();
  const { isPending: isUpdatingUser } = updateUserMutation;

  const uploadPhotoMutation = useUploadPhoto();
  const removePhotoMutation = useRemovePhoto();

  const resetChallengeMutation = useResetChallenge({
    onError: error => {
      Swal.fire(error.message, "", "error");
    },
    onSuccess: async () => {
      // Refetch manuale della query userChallenges
      await refetchUserChallenges();
      Swal.fire("Challenge has been reset!", "", "success");
    }
  });

  const verifyEmailMutation = useVerifyEmail({
    onError: error => {
      Swal.fire(error.message, "", "error");
    },
    onSuccess: () => {
      Swal.fire({
        type: "success",
        title: "Email Verified",
        showConfirmButton: false,
        timer: 1500
      });
    }
  });

  const backToUsers = () => {
    props.history.push("/admin-settings/users");
  };

  const resetChallenge = async values => {
    if (window.confirm("Are you sure you wish to reset this challenge?")) {
      try {
        await resetChallengeMutation.mutateAsync({
          username: values.username,
          challengeType: values.challengeType
        });
      } catch (error) {
        // Error handling è già gestito nell'hook onError callback
        console.error("Reset challenge error:", error);
      }
    }
  };

  const getTotalScore = challengesList => {
    return _.sum(
      challengesList.map(item => _.sum(item.scores.map(item => parseInt(item))))
    );
  };
  const getTotalObtainableScore = challengesList => {
    return _.sum(
      challengesList.map(item =>
        _.sum(item.obtainableScores.map(item => parseInt(item)))
      )
    );
  };

  const getUserChallengeData = (challengesList, userData, userCourseGroups) => {
    const userChallengeData = [];
    const totalUserScore = getTotalScore(challengesList);
    const totalObtainableScore = getTotalObtainableScore(challengesList);
    for (var i = 0; i < challengesList.length; i++) {
      const item = challengesList[i];
      for (var k = 0; k < item.scores.length; k++) {
        const userChallengeDataEntry = {};
        userChallengeDataEntry.Name = userData.name;
        userChallengeDataEntry.SchoolGroups = userCourseGroups.map(
          item => item.label
        );
        userChallengeDataEntry.Email = userData.email;
        userChallengeDataEntry.PrivacyPolicy = userData.privacyPolicy;
        userChallengeDataEntry.ProfileScorecard = userData.profileScorecard;
        userChallengeDataEntry.LearningTopic = item.challengeLearningTopic;
        userChallengeDataEntry.PublishAchievement = userData.publishAchievement;
        /*userChallengeDataEntry.startDate = new Date(
          item.time
        ).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        });*/
        userChallengeDataEntry.TotalGainedScore = totalUserScore;
        userChallengeDataEntry.TotaleObtainableScore =
          i === 0 && k === 0 ? totalObtainableScore : "";
        userChallengeDataEntry.ChallengeNumber = item.challengeType;
        userChallengeDataEntry.ChallengeScore =
          k === 0
            ? _.sum(
                item.scores.map(function(item) {
                  return parseInt(item, 10);
                })
              )
            : "";
        userChallengeDataEntry.ChallengeObtainableScore =
          k === 0
            ? _.sum(
                item.obtainableScores.map(function(item) {
                  return parseInt(item, 10);
                })
              )
            : "";
        userChallengeDataEntry.StepNumber = k + 1;
        userChallengeDataEntry.StepScoreGained = item.scores[k];
        userChallengeDataEntry.StepObtainableScore = item.obtainableScores[k];
        console.log('item', item);
        console.log('stepTime', item.stepTime[k].time);
        
        // Format StepTime in "mm:ss"
        const stepSeconds = Number(item.stepTime[k].time) || 0;
        const stepMinutes = Math.floor(stepSeconds / 60);
        const stepSecs = stepSeconds % 60;
        userChallengeDataEntry.StepTime = `${String(stepMinutes).padStart(2, '0')}:${String(stepSecs).padStart(2, '0')}`;
        
        userChallengeDataEntry.stepMetaSkill = item.stepMetaSkill[k];
        userChallengeDataEntry.stepHardSkill = item.stepHardSkill[k];
        
        // Calculate ChallengeTime as sum of all step times, format in "mm:ss"
        if (k === 0) {
          const totalSeconds = item.stepTime.reduce((sum, step) => sum + (Number(step.time) || 0), 0);
          const challengeMinutes = Math.floor(totalSeconds / 60);
          const challengeSecs = totalSeconds % 60;
          userChallengeDataEntry.ChallengeTime = `${String(challengeMinutes).padStart(2, '0')}:${String(challengeSecs).padStart(2, '0')}`;
        } else {
          userChallengeDataEntry.ChallengeTime = "";
        }
        
        userChallengeData.push(userChallengeDataEntry);
      }
    }
    return userChallengeData;
  };

  const getUserReportData = (challengesList, userData) => {
    const reportData = [];
    const qualificationChallenges = challengesList.filter(c => c.isQualificationSkill === true);
    for (var i = 0; i < qualificationChallenges.length; i++) {
      const item = qualificationChallenges[i];
      const stepCount = (item.scores || []).length;
      for (var k = 0; k < stepCount; k++) {
        const entry = {};
        entry.Name = userData.name || '';
        entry.Surname = userData.surname || '';
        entry.LearningTopic = item.challengeLearningTopic || '';
        entry.ChallengeTitle = item.challengeTitle || '';
        entry.Coach = item.coach || '';
        entry.ChallengeTags = item.challengeTags || '';
        entry.ChallengeScore = (item.scores || [])[k] !== undefined ? parseInt((item.scores || [])[k], 10) : '';
        entry.ChallengeObtainableScore = (item.obtainableScores || [])[k] !== undefined ? parseInt((item.obtainableScores || [])[k], 10) : '';
        if (k === stepCount - 1) {
          const totalScore = _.sum((item.scores || []).map(s => parseInt(s, 10)));
          const totalObtainable = _.sum((item.obtainableScores || []).map(s => parseInt(s, 10)));
          entry['TotalScore/TotalObtainableScore'] = `${totalScore}/${totalObtainable}`;
        } else {
          entry['TotalScore/TotalObtainableScore'] = '';
        }
        entry.StepNumber = k + 1;

        const stepTimeEntry = (item.stepTime || [])[k] || {};
        const stepSeconds = Number(stepTimeEntry.time) || 0;
        const stepMinutes = Math.floor(stepSeconds / 60);
        const stepSecs = stepSeconds % 60;
        entry.StepTime = `${String(stepMinutes).padStart(2, '0')}:${String(stepSecs).padStart(2, '0')}`;
        entry.Note = stepTimeEntry.note || '';
        /* entry.Answer = Array.isArray(stepTimeEntry.answer)
          ? stepTimeEntry.answer.join(', ')
          : (stepTimeEntry.answer || '');
           entry.CorrectAnswer = Array.isArray(stepTimeEntry.correctAnswer)
          ? stepTimeEntry.correctAnswer.join(', ')
          : (stepTimeEntry.correctAnswer || '');*/

        const questionEntry = (item.questions || [])[k] || {};
        entry.Question = questionEntry.questionField
          ? questionEntry.questionField.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim()
          : '';
        entry.Indicator = questionEntry.indicatorName || '';

        reportData.push(entry);
      }
    }
    return reportData;
  };

  if (
    loading ||
    challengeDefinitionsQuery.loading ||
    userDataQuery.loading ||
    userGroupsQuery.loading ||
    userChallengesQuery.loading
  )
    return <LoadingSpinner styles={{ paddingTop: 30 }} />;

  if (error) return `Error! ${error.message}`;
  if (userDataQuery.error) return `Error! ${userDataQuery.error.message}`;
  if (userGroupsQuery.error) return `Error! ${userGroupsQuery.error.message}`;
  if (challengeDefinitionsQuery.error)
    return `Error! ${challengeDefinitionsQuery.error.message}`;

  if (!userDataQuery.data) {
    return <LoadingSpinner styles={{ paddingTop: 30 }} />;
  }

  if (
    !challengeDefinitionsQuery.data ||
    !challengeDefinitionsQuery.data.challengeDefinitions
  ) {
    return <LoadingSpinner styles={{ paddingTop: 30 }} />;
  }

  if (!userGroupsQuery.data || !userGroupsQuery.data.userGroups) {
    return <LoadingSpinner styles={{ paddingTop: 30 }} />;
  }

  const handleRemovePhoto = async userId => {
    try {
      await removePhotoMutation.mutateAsync(userId);
      Swal.fire({
        type: "success",
        title: "Photo Removed",
        showConfirmButton: false,
        timer: 1500
      });
    } catch (error) {
      console.log(error);
      Swal.fire(error.toString(), "", "error");
    }
  };

  const handleVerifyEmail = async id => {
    try {
      await verifyEmailMutation.mutateAsync({ userId: id });
    } catch (error) {
      // Error handling è già gestito nell'hook onError callback
      console.error("Verify email error:", error);
    }
  };

  const handleUpload = async (file, userId) => {
    if (file.size > 2097152) {
      Swal.fire({
        type: "error",
        title: "Error",
        text: "Max Image Size: 2 MB ",
        showConfirmButton: false,
        timer: 2500
      });
      setUploadDialog(false);
      return;
    }
    try {
      await uploadPhotoMutation.mutateAsync({ file, userId });
      Swal.fire({
        type: "success",
        title: "Saved",
        showConfirmButton: false,
        timer: 1500
      });
    } catch (error) {
      Swal.fire({
        type: "error",
        title: "Error",
        text: error?.message || "Failed to upload photo",
        showConfirmButton: false,
        timer: 1500
      });
    }
    setUploadDialog(false);
  };

  const challengeDefinitions =
    challengeDefinitionsQuery.data.challengeDefinitions;
  const myData = data?.me; // Get from Zustand store instead of GraphQL
  const userData = userDataQuery.data;
  const isDisabled = myData?.userRole !== RolesTypes.SUPERUSER;

  // Protezione per courseGroups che potrebbe essere undefined
  const separateData = (userData.courseGroups || []).map(item => item);
  const userCourseGroups = [];
  separateData.map(item =>
    userCourseGroups.push({ value: item.id, label: item.name })
  );
  let userChallengeData = [];
  const challengesList = [];
  const groupsChallenges = (userData.courseGroups || []).map(
    item => item.groupChallenges || []
  );
  
  groupsChallenges.map(item =>
    item.forEach(item => {
      challengesList.push(item);
    })
  );
  
  const userChallenges = [];
  const UniqueChallengeList = [
    ...new Set(challengesList.sort((a, b) => a - b))
  ];

  UniqueChallengeList.forEach(item => {
    const found = challengeDefinitions.find(i => i.id === parseInt(item));
    userChallenges.push(found);
  });

  const totalScore = userChallenges
    .map(item => item?.totalObtainableScore ?? 0)
    .reduce((a, b) => a + b, 0);

  const challenges = userChallengesQuery.data.userChallenges.records;

  const userChallengesListTemp = _.uniqBy(challenges, "challengeType");
  if (userChallengesListTemp.length !== userChallengesList.length) {
    setUserChallengesList(userChallengesListTemp);
  }

  userChallengeData = getUserChallengeData(
    userChallengesList,
    userData,
    userCourseGroups
  );
  const userReportData = getUserReportData(userChallengesList, userData);
  const totalUserScore = getTotalScore(userChallengesList);

  return (
    <Layout name="User Profile">
      <Formik
        initialValues={{
          _id: id,
          name: userData.name,
          surname: userData.surname,
          sigla: userData.sigla,
          email: userData.email,
          userRole: userData.userRole,
          birthDate: userData.birthDate,
          expirationDate: userData.expirationDate,
          country: userData.country,
          phone: userData.phone,
          city: userData.city,
          description: userData.description,
          courseGroups: (userData.courseGroups || []).map(item => item.id),
          linkedin: userData.linkedin
        }}
        onSubmit={async (values, actions) => {
          try {
            actions.setSubmitting(true);
            const { email, _id, ...rest } = values;
            const dataToSend = {
              key: _id,
              ...rest
            };
            await updateUserMutation.mutateAsync(dataToSend);

            Swal.fire({
              type: "success",
              title: "Saved",
              showConfirmButton: false,
              timer: 1500
            });
          } catch (error) {
            console.log(error);
            Swal.fire({
              type: "error",
              title: "Error saving user",
              text: error?.message || "Failed to update user",
              showConfirmButton: false,
              timer: 1500
            });
          } finally {
            actions.setSubmitting(false);
          }
        }}
      >
        {propsFormik => (
          <form onSubmit={propsFormik.handleSubmit}>
            <div className="row">
              <div className="col-md-4 d-flex align-items-stretch flex-wrap">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title">Profile picture</h5>
                  </div>
                  <div className="card-body" style={{ flex: "0 1 auto" }}>
                    <img
                      src={
                        userData.photo
                          ? userData.photo
                          : env.PUBLIC_URL + "/assets/img/default-avatar.png"
                      }
                      alt="Profile gams"
                      className="rounded-circle img-fluid float-left w-50"
                    />

                    <h5>
                      {/* jpg, png - max dimensions 150x150px, max weight 3 MB */}
                    </h5>

                    <Button
                      className="btn btn-outline-primary"
                      value="upload"
                      onClick={() => setUploadDialog(true)}
                    >
                      Upload your photo
                    </Button>
                    <Button
                      className="btn btn-outline-primary"
                      value="upload"
                      onClick={() => {
                        Swal.fire({
                          title: "Are you sure you want to remove your photo?",
                          showCancelButton: true,
                          confirmButtonText: `Yes`
                        }).then(result => {
                          if (result.value) {
                            handleRemovePhoto(id);
                          }
                        });
                      }}
                    >
                      Remove photo
                    </Button>

                    <UploadPhotoDialog
                      title="Upload your photo"
                      handleUndo={() => setUploadDialog(false)}
                      handleClose={() => setUploadDialog(false)}
                      idUser={id}
                      handleUpload={handleUpload}
                      open={uploadDialog}
                      saveName="Save"
                      button={true}
                    >
                      {" "}
                      Select your photo. The optimal size is 360x360px
                    </UploadPhotoDialog>
                  </div>
                  <div style={{ marginTop: 12 }}>
                    <div className="card-header">
                      <h5 className="card-title">User Profile Scorecard</h5>
                    </div>
                    <div className="card-body" style={{ paddingTop: 5, display: 'flex', flexDirection: 'column', gap: 8 }}>
                      <Button
                        variant="outlined"
                        size="medium"
                        style={{ color: "#616161" }}
                        href={"/psc/" + userData.profileScoreCardSerialNumber}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        Go to Public Profile Scorecard
                      </Button>
                      <Button
                        variant="outlined"
                        size="medium"
                        style={{ color: "#616161" }}
                        href={"/qsc/" + userData.key}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        Go to Qualification Scorecard
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title">Profile External Link</h5>
                  </div>
                  <div className="card-body">
                    <h3>
                      <b>
                        <div className="form-group bmd-form-group">
                          <input
                            defaultValue={propsFormik.values.linkedin}
                            type="text"
                            className="form-control"
                            name="linkedin"
                            onChange={propsFormik.handleChange}
                            onBlur={propsFormik.handleBlur}
                          />
                        </div>{" "}
                      </b>
                    </h3>
                  </div>
                </div>
                {myData?.userRole === RolesTypes.SUPERUSER && (
                  <div className="card">
                    <div className="card-header">
                      <h5 className="card-title">Verify Email</h5>
                    </div>
                    <div className="card-body">
                      <Button
                        className="btn btn-outline-primary"
                        onClick={() =>
                          Swal.fire({
                            title:
                              "Are you sure you want to verify email user?",
                            showCancelButton: true,
                            confirmButtonText: `Yes`
                          }).then(result => {
                            if (result.value) handleVerifyEmail(id);
                          })
                        }
                      >
                        Verify Email
                      </Button>
                    </div>
                  </div>
                )}
              </div>
              <div className="col-md-3 d-flex align-items-stretch flex-wrap">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title">Name</h5>
                  </div>
                  <div className="card-body">
                    <h3>
                      <b>
                        <div className="form-group bmd-form-group">
                          <input
                            defaultValue={propsFormik.values.name}
                            type="text"
                            className="form-control"
                            name="name"
                            onChange={propsFormik.handleChange}
                            onBlur={propsFormik.handleBlur}
                          />
                        </div>
                      </b>
                    </h3>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title">Last name</h5>
                  </div>
                  <div className="card-body">
                    <h3>
                      <b>
                        <div className="form-group bmd-form-group">
                          <input
                            defaultValue={propsFormik.values.surname}
                            type="text"
                            className="form-control"
                            name="surname"
                            onChange={propsFormik.handleChange}
                            onBlur={propsFormik.handleBlur}
                          />
                        </div>
                      </b>
                    </h3>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title">Sigla</h5>
                  </div>
                  <div className="card-body">
                    <h3>
                      <b>
                        <div className="form-group bmd-form-group">
                          <input
                            defaultValue={propsFormik.values.sigla}
                            type="text"
                            className="form-control"
                            name="sigla"
                            onChange={propsFormik.handleChange}
                            onBlur={propsFormik.handleBlur}
                          />
                        </div>
                      </b>
                    </h3>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title">Birthdate</h5>
                  </div>
                  <div className="card-body">
                    <h3>
                      <b>
                        <div className="form-group bmd-form-group">
                          <h5 className="card-title">
                            {moment(propsFormik.values.birthDate).format(
                              "DD-MM-YYYY"
                            )}
                          </h5>
                        </div>
                      </b>
                    </h3>
                  </div>
                </div>
                {myData?.userRole === RolesTypes.SUPERUSER ? (
                  <div className="card">
                    <div className="card-header">
                      <h5 className="card-title">
                        Expiration Date {myData?.userRole}{" "}
                      </h5>
                    </div>
                    <div className="card-body">
                      <TextField
                        name="expirationDate"
                        label="Change Expiration date"
                        type="date"
                        onChange={event => {
                          propsFormik.setFieldValue(
                            "expirationDate",
                            event.target.value
                          );
                        }}
                        defaultValue={moment(
                          propsFormik.values.expirationDate
                        ).format("YYYY-MM-DD")}
                        InputLabelProps={{
                          shrink: true
                        }}
                        fullWidth
                        disabled={isDisabled}
                      />
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-md d-flex align-items-stretch flex-wrap">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title">email</h5>
                  </div>
                  <div className="card-body align-items-center justify-content-center">
                    <div className="form-group bmd-form-group align-items-center">
                      {/* ✅ Cambia input in h5 per renderlo non editabile */}
                      <h5 className="card-title">{propsFormik.values.email}</h5>

                      {/* ❌ RIMUOVI questo input editabile
                                                                                <input defaultValue={propsFormik.values.email}
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    name="email"
                                                                                    onChange={propsFormik.handleChange}
                                                                                    onBlur={propsFormik.handleBlur} />
                                                                                */}

                      {/*<Link
                        to={{
                          pathname: `/password/${id}`,
                          params: { id: id }
                        }}
                        className="btn btn-outline-primary"
                      >
                        Edit Password
                      </Link>*/}
                    </div>
                  </div>
                </div>
                {myData?.userRole === RolesTypes.SUPERUSER ? (
                  <div className="card">
                    <div className="card-header">
                      <h5 className="card-title">Access Rights</h5>
                    </div>
                    <div className="card-body align-items-center justify-content-center">
                      <div className="form-group bmd-form-group align-items-center">
                        <RadioGroup
                          name="userRole"
                          value={propsFormik.values.userRole}
                          onChange={propsFormik.handleChange}
                        >
                          <FormControlLabel
                            value={RolesTypes.STUDENT}
                            control={<Radio />}
                            label="Student"
                          />
                          <FormControlLabel
                            value={RolesTypes.COACH}
                            control={<Radio />}
                            label="Coach"
                          />
                          {myData?.userRole === RolesTypes.SUPERUSER ? (
                            <FormControlLabel
                              value={RolesTypes.SUPERUSER}
                              control={<Radio />}
                              label="SuperUser"
                            />
                          ) : null}
                        </RadioGroup>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="row">
              <div className="col-md-7 d-flex align-items-stretch">
                <div className="card">
                  <div className="card-header card-header-warning">
                    <h5 className="card-title">Contacts: </h5>
                  </div>
                  <div className="card-body">
                    <div className="form-group">
                      <label htmlFor="cityInput" className="bmd-label-floating">
                        City
                      </label>
                      <h5 className="card-title">{propsFormik.values.city}</h5>
                    </div>
                    <div className="form-group">
                      <label className="bmd-label-floating">Country</label>
                      <h5 className="card-title">
                        {propsFormik.values.country}
                      </h5>
                    </div>
                    <div className="form-group">
                      <label className="bmd-label-floating">Phone</label>
                      <h5 className="card-title">{propsFormik.values.phone}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-5 d-flex align-items-stretch">
                <div className="card">
                  <div className="card-header card-header-warning">
                    <h5 className="card-title">School Group</h5>
                  </div>
                  <div className="card-body">
                    <Select
                      defaultValue={userCourseGroups}
                      name="ourseGroups"
                      onChange={values => {
                        // Fix: gestisci il caso in cui values sia null/undefined (deseleziona tutto)
                        const newCourseGroups = values ? values.map(item => item.value) : [];                    
                        propsFormik.setFieldValue(
                          "courseGroups",
                          newCourseGroups
                        );
                      }}
                      options={userGroupsQuery.data.userGroups.records.map(
                        item => ({ value: item._id, label: item.name })
                      )}
                      placeholder={"Select course groups"}
                      isMulti={true}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="col-md d-flex align-items-stretch">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">
                      {propsFormik.values.name} SCORE
                    </h4>
                  </div>
                  <div className="card-body d-flex align-items-center justify-content-center">
                    <h3>
                      {totalUserScore}/{totalScore}
                    </h3>
                  </div>
                </div>
              </div>
              <ItemsGrid
                columns={columns}
                columnsName={columnsName}
                title={`${propsFormik.values.name} Challenges`}
                items={userChallengesList}
                reset={(index, item) => resetChallenge(item)}
                edit={(index, item) =>
                  props.history.push(`/challenge/end/${item._id}/0`)
                }
                pagination={true}
                rowsPerPage={10}
              />
              <CSVService
                label={"Download Challenge User Data"}
                fileName={userData.name + ".csv"}
                csvData={userChallengeData}
              />
              <CSVService
                label={"Download Report User Data"}
                fileName={userData.name + "_report.csv"}
                csvData={userReportData}
              />
            </div>

            <div></div>
            <div className="row" style={{ justifyContent: "center" }}>
              { isUpdatingUser && <LoadingSpinner></LoadingSpinner> }
              { !isUpdatingUser && <Button
                className="btn btn-fill btn-rose"
                type="submit"
                variant="contained"
                size="large"
              >
                <SaveIcon />
                Save
              </Button> }
            </div>
            <div className="row">
              <div className="col-md-12">
                <Box
                  style={{ display: "flex", justifyContent: "space-around" }}
                >
                  <Button className="btn btn-primary" onClick={backToUsers}>
                    Back to Users
                  </Button>
                  { isDeletingUser && <LoadingSpinner></LoadingSpinner> }
                  { !isDeletingUser && <Button
                    className="btn  btn-primary"
                    onClick={() => {
                      Swal.fire({
                        title:
                          "Are you sure you want to delete the user " + userData.name + " " + userData.surname + 
                          " ?",
                        showCancelButton: true,
                        confirmButtonText: `Yes`
                      }).then(result => {
                        if (result.value) {
                          deleteUserMutation.mutateAsync(id);
                        }
                      });
                    }}
                  >
                    Delete User
                  </Button>}
                </Box>
              </div>
              <div className="col-md-6"></div>
              <div
                className="col-md-6"
                style={{ justifyContent: "flex-end", alignContent: "flex-end" }}
              ></div>
            </div>
          </form>
        )}
      </Formik>
    </Layout>
  );
};

export default UserProfile;
